__turbopack_context__.v({
  "label": "sGqMhG_label",
  "toggle": "sGqMhG_toggle",
});
